import { ArenaSegmentDto, ForcePlayerDto, GetArenaSegmentDto } from '@services/_api';
import client from '@services/client';

export const getArenaSegments = async (data: GetArenaSegmentDto) => {
  return client.api.arenaSegmentControllerGetArenaSegments(data);
};

export const createArenaSegment = async (segmentData: ArenaSegmentDto) => {
  return client.api.arenaSegmentControllerCreateArenaSegment(segmentData);
};

export const forcePlayer = async (data: ForcePlayerDto) => {
  return client.api.arenaSegmentControllerForcePlayer(data);
};

export const getArenaSegmentHistory = async (environment: string | undefined) => {
  return client.api.arenaSegmentHistoryControllerGetAll({ where: { environment } });
};
